/**
 * Sprungziele ins GTM-Setup (Zielkundenprofile, Personas, Angebote). Die
 * Seite oeffnet per `?tab=` den Reiter und per `?id=` den Eintrag.
 */
export type GtmTab = 'icp' | 'persona' | 'offer';

export function gtmPfad(tab: GtmTab, id?: string | null): string {
  const q = new URLSearchParams({ tab });
  if (id) q.set('id', id);
  return `/gtm-setup?${q.toString()}`;
}
